exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa-pencil[data-v-67801ac1] {\n  color: #838383;\n}\n.editor[data-v-67801ac1] {\n  padding-top: 1rem;\n}\nbutton[data-v-67801ac1] {\n  cursor: pointer;\n  background: transparent;\n  border: none;\n}\n", ""]);

// exports
